import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Truck } from "@phosphor-icons/react";

const HERO = "https://images.pexels.com/photos/12261472/pexels-photo-12261472.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const LOGO = "https://customer-assets-lxgj4vgw.emergentagent.net/job_fleet-command-177/artifacts/ilhe4ttw_Velvet%20GPS%20Logo.jpeg";

const DEMO = [
  ["velvetgps@gmail.com", "Super Admin"],
  ["dealer@velvetgps.com", "Dealer"],
  ["installer@velvetgps.com", "Installer"],
  ["control@velvetgps.com", "Control Room"],
  ["fleet@velvetgps.com", "Fleet Admin"],
];

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("velvetgps@gmail.com");
  const [password, setPassword] = useState("Charlie@2026");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) nav("/");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      {/* Left: form */}
      <div className="flex flex-col justify-center px-8 sm:px-16 py-12">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-12 h-12 rounded-md bg-white flex items-center justify-center overflow-hidden">
            <img src={LOGO} alt="Velvet GPS" className="w-full h-full object-contain" />
          </div>
          <div>
            <div className="font-display font-black text-xl tracking-tight leading-none">VELVET GPS</div>
            <div className="label-caps text-[9px]">AIS-140 Command Center</div>
          </div>
        </div>

        <h1 className="font-display font-black text-4xl tracking-tight">Control Center Login</h1>
        <p className="text-sm text-muted-foreground mt-1 mb-8">
          Sign in to your fleet command dashboard.
        </p>

        <form onSubmit={submit} className="space-y-4 max-w-sm">
          <div>
            <label className="label-caps">Email</label>
            <input
              data-testid="login-email"
              type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full bg-card border border-border rounded-sm px-3 py-2.5 text-sm focus:ring-2 focus:ring-primary focus:outline-none"
              required
            />
          </div>
          <div>
            <label className="label-caps">Password</label>
            <input
              data-testid="login-password"
              type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full bg-card border border-border rounded-sm px-3 py-2.5 text-sm focus:ring-2 focus:ring-primary focus:outline-none"
              required
            />
          </div>
          {error && <div data-testid="login-error" className="text-sm text-destructive">{error}</div>}
          <button
            data-testid="login-submit"
            type="submit" disabled={loading}
            className="w-full bg-primary text-white font-semibold rounded-sm py-2.5 text-sm hover:bg-primary/90 disabled:opacity-60 transition-colors"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>

        <div className="mt-8 max-w-sm">
          <div className="label-caps mb-2">Quick demo accounts (pwd: Charlie@2026)</div>
          <div className="grid grid-cols-1 gap-1">
            {DEMO.map(([em, role]) => (
              <button
                key={em}
                data-testid={`demo-${role.toLowerCase().replace(/\s/g, "-")}`}
                onClick={() => { setEmail(em); setPassword("Charlie@2026"); }}
                className="text-left text-xs px-3 py-1.5 border border-border rounded-sm hover:border-primary flex justify-between"
              >
                <span className="text-muted-foreground">{role}</span>
                <span className="font-mono">{em}</span>
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Right: hero */}
      <div className="hidden lg:block relative">
        <img src={HERO} alt="fleet" className="absolute inset-0 w-full h-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/60 to-transparent" />
        <div className="absolute bottom-12 left-12 right-12">
          <Truck size={40} weight="fill" className="text-primary mb-4" />
          <div className="font-display font-black text-4xl tracking-tight leading-tight">
            Track. Command. Comply.
          </div>
          <p className="text-sm text-muted-foreground mt-2 max-w-md">
            End-to-end AIS-140 GPS IoT platform — live tracking, emergency control,
            device management, dealer ERP and government integrations.
          </p>
        </div>
      </div>
    </div>
  );
}
